<template>

  <div>
    <section id="pricing" class="pricing">
      <div class="container">

        <div class="hidden-sm row m-b-lg">
          <div class="col-lg-12 text-center">
            <!--          <div class="navy-line"></div>-->
            <h1>Only pay for what you use.</h1>
            <p>Estimate the volume of data you'll ingest per month.
            <p>

            <p></p>
            <range-slider
              class="slider"
              min="0"
              max="2000"
              step="10"
              :mouseup="clickEvent('price_slider')"
              v-model="sliderValue">
            </range-slider>
            <span class="mb-10" style="position: relative; top: -5px;"><strong>{{ sliderValue }} GB</strong></span>
            <p></p>
            <p><em class="small">(You're only charged for the data you ingest each month beyond any minimum
              commitment.)</em></p>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 wow zoomIn animated" style="visibility: visible;">
            <ul class="pricing-plan list-unstyled">
              <li class="pricing-title btn-primary">
                Developer
              </li>
              <li class="pricing-desc">
                Ingest data locally, replicating from any source system generating schemas and optimised output
                formatted data.
              </li>
              <li class="pricing-price">
                <span>FREE</span>
              </li>
              <li>
                Max 100MB / run
              </li>
              <li>
                Local files and streams
              </li>
              <li>
                S3 Input Plugin
              </li>
              <li>
                <a class="btn btn-secondary btn-xs" href="/deploy-wizard" v-on:click="clickEvent('developer')">Install
                  CLI</a>
              </li>
            </ul>
          </div>

          <div class="visible-sm row m-b-lg">
            <div class="col-lg-12 text-center">
              <!--          <div class="navy-line"></div>-->
              <h1>Only pay for what you use.</h1>
              <p>Estimate the volume of data you'll ingest per month.
              <p>

              <p></p>
              <range-slider
                class="slider"
                min="0"
                max="2000"
                step="10"
                :mouseup="clickEvent('gb_slider')"
                v-model="sliderValue">
              </range-slider>
              <span class="mb-10" style="position: relative; top: -5px;"><strong>{{ sliderValue }} GB</strong></span>
              <p></p>
              <p><em class="small">(You're only charged for the data you ingest each month beyond any minimum
                commitment.)</em></p>
            </div>
          </div>
          <div class="col-lg-4 wow zoomIn animated" style="visibility: visible;">
            <ul class="pricing-plan list-unstyled selected">
              <li class="pricing-title btn-primary">
                Business
              </li>
              <li class="pricing-desc">
                Deploy resilient, declarative data pipelines - optimising your datalake automatically.
              </li>
              <li class="pricing-price">
                <span>${{ monthlyPrice }}</span> / month
              </li>
              <li>
                ${{ pricePerGb.toFixed(2) }} / GB
              </li>
              <li>
                All Input Plugins
              </li>
              <li>
                All Output Plugins
              </li>
              <li>
                Sync Schemas
              </li>
              <li>
                Schema Evolution
              </li>
              <li>
                Data Catalog Time Travel
              </li>
              <li>
                Schema/Data Diff
              </li>
              <li>
                Business Hours Support
              </li>
              <li class="plan-action">
                <a class="btn btn-secondary btn-xs" href="/deploy-wizard" v-on:click="clickEvent('business')">Deploy</a>
              </li>
            </ul>
          </div>

          <div class="col-lg-4 wow zoomIn animated" style="visibility: visible;">
            <ul class="pricing-plan list-unstyled">
              <li class="pricing-title btn-primary">
                Enterprise
              </li>
              <li class="pricing-desc">
                Battle tested data platform meets boutique consultancy and support.
              </li>
              <li class="pricing-price">
                <span>Contact for Pricing</span>
              </li>
              <li>
                All Business Features
              </li>
              <li>
                SOC, SSO, Private Deployment
              </li>
              <li>
                White Glove Support
              </li>
              <li>
                <a class="btn btn-secondary btn-xs" href="/deploy-wizard"
                   v-on:click="clickEvent('enterprise')">Contact</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row m-t-lg">
          <div class="col-lg-12 text-left m-t-lg">
            <!--          <p>* Free Developer version not for commercial use.</p>-->
          </div>
        </div>
      </div>


      <RefundsSection></RefundsSection>

    </section>


    <FooterSignup></FooterSignup>
  </div>


</template>

<script>
import RangeSlider from 'vue-range-slider'
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css'
// import {debounce} from 'lodash';
import RefundsSection from './RefundsSection.vue'
import FooterSignup from '../FooterSignup.vue'


export default {
  data() {
    return {
      sliderValue: 415, // Amount of GB used
      pricePerGbSeries: [0.9, 0.75, 0.5, 0.375, 0.25],
      pricePerGbStep: 250, // The step for price scaling down
      minimumCharge: 349, // Minimum charge
    }
  },
  components: {
    RangeSlider,
    RefundsSection,
    FooterSignup
  },
  head: {
    title: {
      inner: 'Pricing',
      separator: '-',
      complement: 'Value based, simple pricing'
    },
    meta: [
      {
        name: 'description',
        content: 'Pricing for the Skippr data platform.'
      }
    ]
  },
  computed: {
    pricePerGb() {
      let index = Math.floor(this.sliderValue / this.pricePerGbStep);
      index = Math.min(index, this.pricePerGbSeries.length - 1);
      return this.pricePerGbSeries[index];
    },
    monthlyPrice() {
      let total = 0;
      let remainingGB = this.sliderValue;

      for (let i = 0; i < this.pricePerGbSeries.length; i++) {
        if (remainingGB <= 0) break;

        let pricePerGB = this.pricePerGbSeries[i];
        let gbToCharge = Math.min(this.pricePerGbStep, remainingGB);

        total += gbToCharge * pricePerGB;
        remainingGB -= gbToCharge;
      }

      // Charge for remaining GB if any at the last known rate
      if (remainingGB > 0) {
        total += remainingGB * this.pricePerGbSeries[this.pricePerGbSeries.length - 1];
      }

      // Apply minimum charge
      return Math.max(total, this.minimumCharge);
    }
  },
  methods: {
    clickEvent(name) {
      // debounce(() => {
      console.log('drag end')
      this.$gtag.event('click', {
        event_category: 'pricing',
        event_label: name,
      });
      // }, 3000);
    },
  }
}


</script>

<style>
.slider {
  /* overwrite slider styles */
  width: 354px;
}

.range-slider-fill {
  background-color: #ff0066;
}
</style>
